import React from 'react'
import ContactForm from '../components/ContactForm'
import { useLanguage } from '../context/LanguageContext'

export default function Contact() {
  const { language, t } = useLanguage()

  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2C302E] antialiased">
      {/* Hero Banner */}
      <section className="relative h-[40vh] sm:h-[45vh] min-h-[300px] flex items-end overflow-hidden pt-24">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/assets/b84a6f1a-652f-4145-af52-d7d46fab18e5/d807c5de-eaa2-4418-a220-66a0980d29c9.png"
            alt="Wecas ApS Kontakt"
            className="w-full h-full object-cover object-center"
          />
          {/* Dark overlay for text contrast */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#2C302E] via-[#2C302E]/70 to-transparent" />
        </div>

        <div className="relative z-10 mx-auto max-w-7xl w-full px-6 md:px-12 pb-12 sm:pb-16">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-bold tracking-wider text-[#a78458] bg-white/95 px-3 py-1 uppercase mb-4 rounded-none">
              {language === 'da' ? 'Kontakt os 24/7' : 'Contact us 24/7'}
            </span>
            <h1 className="font-marcellus text-3xl sm:text-4xl md:text-5xl font-light tracking-[0.08em] text-[#FAF8F5] uppercase leading-tight">
              {language === 'da' ? 'Kontakt Wecas' : 'Contact Wecas'}
            </h1>
            <p className="text-sm sm:text-base text-[#FAF8F5]/80 mt-2 max-w-xl">
              {language === 'da' 
                ? 'Vi står klar til at hjælpe dig hele døgnet rundt. Få et uforpligtende tilbud eller kontakt vores afdelinger direkte.' 
                : 'We are ready to help you around the clock. Get a non-binding quote or contact our departments directly.'}
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form, Departments & Team Section */}
      <ContactForm />
    </div>
  )
}
